import axios from 'axios'
import { ANEXAR_DOCUMENTO_RESERVA_COM_REEMBOLSO_SOLICITADO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function anexarDocumentoReservaReembolsoSolicitado (parametros) {
  const url = `${URL}/reserva/anexar-documento-reembolso`;
  return dispatch => axios.post(url, parametros, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: ANEXAR_DOCUMENTO_RESERVA_COM_REEMBOLSO_SOLICITADO,
        payload: response
      })
  );
}
